import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useQueryClient } from '@tanstack/react-query'
import Button from '@/components/ui/Button'
import { signOut, useProfile } from '@/auth/useAuth'

const NAV = [
  { to: '/', key: 'nav.dashboard', end: true },
  { to: '/brews', key: 'nav.brews', end: false },
  { to: '/auswertung', key: 'nav.stats', end: false },
  { to: '/geteilt', key: 'nav.feed', end: false },
  { to: '/muehlen', key: 'nav.grinders', end: false },
  { to: '/maschinen', key: 'nav.machines', end: false },
  { to: '/filter', key: 'nav.brewers', end: false },
  { to: '/bohnen', key: 'nav.beans', end: false },
  { to: '/wasser', key: 'nav.waters', end: false },
  { to: '/einstellungen', key: 'nav.settings', end: false },
]

export default function AppLayout() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const profile = useProfile()

  async function handleSignOut() {
    await signOut()
    // Ohne das Leeren des Caches sähe der nächste Nutzer an diesem Gerät kurz
    // die Daten des vorherigen.
    queryClient.clear()
    void navigate('/login', { replace: true })
  }

  return (
    <div className="flex min-h-full flex-col">
      <header className="border-crema-200 dark:border-roast-700 dark:bg-roast-900/60 border-b bg-white/60 backdrop-blur">
        <div className="mx-auto flex max-w-4xl items-center justify-between gap-4 px-5 py-3">
          <span className="font-semibold tracking-tight">{t('app.name')}</span>
          <div className="flex items-center gap-3">
            {profile.data && (
              <span className="text-roast-500 dark:text-crema-300/70 hidden text-sm sm:inline">
                {profile.data.display_name}
                {profile.data.role === 'admin' && (
                  <span className="bg-crema-200 text-roast-700 dark:bg-roast-700 dark:text-crema-200 ml-2 rounded px-1.5 py-0.5 text-xs font-medium">
                    {t('common.admin')}
                  </span>
                )}
              </span>
            )}
            <Button variant="secondary" onClick={() => void handleSignOut()}>
              {t('auth.signOut')}
            </Button>
          </div>
        </div>

        <nav className="mx-auto max-w-4xl px-5">
          {/* Waagerecht scrollbar statt umbrechend — auf dem Telefon bleibt die
              Kopfzeile dadurch einzeilig. */}
          <ul className="-mb-px flex gap-1 overflow-x-auto">
            {NAV.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) =>
                    `inline-block border-b-2 px-3 py-2 text-sm whitespace-nowrap transition-colors ${
                      isActive
                        ? 'border-roast-500 font-medium'
                        : 'hover:border-crema-300 dark:hover:border-roast-600 border-transparent'
                    }`
                  }
                >
                  {t(item.key)}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </header>

      <main className="mx-auto w-full max-w-4xl flex-1 px-5 py-8">
        <Outlet />
      </main>
    </div>
  )
}
